import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { RiErrorWarningLine } from '@/shared/icons/remix'
import { useSpProfile } from '@/features/rewards/api'
import { EKYC_UNDER_REVIEW_BANNER_MESSAGE, isEkycUnderReview } from '../lib/ekycUi'

/**
 * Under-review status strip — Home and Rewards when ekycStatus is under_review.
 */
export function EkycUnderReviewBanner() {
  const { data: profile } = useSpProfile()
  if (!isEkycUnderReview(profile?.ekycStatus)) return null

  return (
    <Box
      role="status"
      aria-live="polite"
      data-testid="ekyc-under-review-banner"
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: '10px',
        pl: '15px',
        pr: '19px',
        py: '14px',
        borderRadius: '12px',
        bgcolor: 'rgba(254, 210, 145, 0.14)',
        border: '1px solid rgba(255, 152, 0, 0.14)',
        boxSizing: 'border-box',
        width: '100%',
        mb: 3,
      }}
    >
      <Box
        component="span"
        sx={{
          display: 'flex',
          width: 18,
          height: 18,
          flexShrink: 0,
          color: '#F59E0B',
          lineHeight: 0,
          mt: '1px',
        }}
        aria-hidden
      >
        <RiErrorWarningLine size={18} />
      </Box>
      <Typography
        sx={{
          fontSize: '14px',
          lineHeight: '18.75px',
          fontWeight: 400,
          color: '#F59E0B',
        }}
      >
        {EKYC_UNDER_REVIEW_BANNER_MESSAGE}
      </Typography>
    </Box>
  )
}
